import { ButtonSimple } from '@jollywise/jollygoodgame/src/input/ButtonSimple';
import { CURSOR_OVER } from '../constants/Constants';

export class BtnSesame extends ButtonSimple {
  constructor(scene, opts) {
    super(scene, opts);
    this.scale = opts.resolution ? 1 / opts.resolution : 1;
  }
  enableInteractive() {
    this.setInteractive({ cursor: CURSOR_OVER });
  }

  disable() {
    if (!this.buttonEnabled) return;
    super.disable();
    this.alpha = 1;
  }

  // button events
  enterButtonHoverState() {
    if (this.buttonEnabled) {
      if (this._vo && !this.scene.game.vo.isPlaying) {
        this.scene.sys.game.soundController.playButtonAudio(this._vo.sheet, this._vo.id);
      }
      this.setDisplay(`${this.costume}_over`);
      this._updateAccessibilityItem();
    }
  }

  enterButtonClickState() {
    if (this._vo) this.scene.sys.game.soundController.playButtonAudio(this._vo.sheet, this._vo.id);
    super.enterButtonClickState();
  }
}
